import axios from './axios';

export type TEpdBadge = {
  image_link: string;
  body: string;
  meta: {
    level: number;
    is_active: boolean;
  };
};

// При отсутствии значка ручка отвечает 200 с пустым телом
const fetchEpdBadge = () => {
  return axios.get<TEpdBadge | ''>('/webapi/icons/v1/epd-badge').then(res => res.data || null);
};

export { fetchEpdBadge };
